import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { ErrorToast, SuccessToast } from "@/components/toast/Toasts";
import {
  ICustomerDetails,
  IPendingCartCustomer,
  IPendingCartCustomerPayload,
} from "./customerModel";

export const findAllCustomer = createAsyncThunk(
  "Customer/FindAllCustomer",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Customer/FindAllCustomer`,
        {},
      );
      return response.data?.Data.map((item: any) => ({
        ...item,
        CustomerType:
          typeof item.CustomerType === "string"
            ? item.CustomerType.split(",").filter(Boolean)
            : item.CustomerType || [],
        IsActive: item.IsActive || false,
      }));
    } catch (error: any) {
      console.error("Error fetching customers:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertCustomer = createAsyncThunk(
  "Customer/InsertCustomer",
  async (customerData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Customer/InsertCustomer`,
        customerData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating customer:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateCustomer = createAsyncThunk(
  "Customer/UpdateCustomer",
  async (customerData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Customer/UpdateCustomer`,
        customerData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating customer:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteCustomer = createAsyncThunk(
  "Customer/DeleteCustomer",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Customer/DeleteCustomer`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting customer:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findByIDCustomer = createAsyncThunk(
  "Customer/FindByIDCustomer",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Customer/FindByIDCustomer`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ...result,
        CustomerType:
          typeof result?.CustomerType === "string"
            ? result?.CustomerType?.split(",")?.filter(Boolean)
            : result?.CustomerType || [],
        IsActive: result?.IsActive || false,
      } as ICustomerDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching customer:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInActiveCustomer = createAsyncThunk(
  "Customer/ActiveInActiveCustomer",
  async (data: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Customer/ActiveInActiveCustomer`,
        data,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error in status change:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findAllActiveCustomer = createAsyncThunk(
  "Customer/FindAllActiveCustomer",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Customer/FindAllActiveCustomer`,
      );
      return response.data?.Data || [];
    } catch (error: any) {
      console.error("Error Fetching active customers:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findPendingCartCustomerList = createAsyncThunk(
  "Customer/PendingCartCustomerList",
  async (payload?: IPendingCartCustomerPayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Customer/PendingCartCustomerList`,
        {
          FullName: payload?.FullName ?? "",
        },
      );
      const data = response.data?.Data || [];
      return data.map((item: any) => ({
        ...item,
        CustomerType:
          typeof item.CustomerType === "string"
            ? item.CustomerType.split(",")
                .map((s: string) => s.trim())
                .filter(Boolean)
            : Array.isArray(item.CustomerType)
            ? item.CustomerType
            : [],
        IsActive: item.IsActive ?? true,
        IsFollowupCompleted: Boolean(item.IsFollowupCompleted),
      })) as IPendingCartCustomer[];
    } catch (error: any) {
      console.error("Error fetching pending cart customers:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

